import {useGetPortalTeamQuery} from "../store/generated/api";
import {useAuth} from "./useAuth";

/**
 * True for university team admins whose semester settings are still unlocked.
 * The lock is set on the first save, so an unlocked team is one that has not
 * picked its own dates yet and is running on the default semester windows.
 */
export function useSemesterSetupPrompt(): boolean {
    const {user} = useAuth();
    const {data} = useGetPortalTeamQuery({page: 0, size: 10});

    const hasAdminRole = user?.roles?.some(role => ['ADMIN', 'PLATFORM_ADMIN'].includes(role)) === true;
    const team = data?.team;

    return hasAdminRole
        && team?.isUniversity === true
        && team?.educationalSettings?.settingsLocked !== true;
}
